import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home, Login, Services } from "./pages";
import EmpedanceMainLayout from "./components/layouts/EmpedanceMainLayout";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./pages/ProtectedRoute";
import AuthRoute from "./pages/AuthRoute";
import AuthLayout from "./components/layouts/AuthLayout";
import Staff from "./pages/staff/Staff";
import AddStaff from "./pages/staff/AddStaff";
import Students from "./pages/students/Students";
import AddStudents from "./pages/students/AddStudents";
import Classes from "./pages/classes/Classes";
import Groups from "./pages/groups-houses/Groups";
import Admissions from "./pages/admissions/Admissions";
import ViewStaffProfile from "./pages/staff/view-profile/ViewStaffProfile";
import StudentDataImport from "./pages/students/StudentDataImport";
import Messages from "./pages/messages/Messages";
import SendMessage from "./pages/messages/SendMessage";
import Queries from "./pages/queries/Queries";
import ViewStudentProfile from "./pages/students/student-profile/StudentProfile";
import AcademicPreference from "./pages/academic-preference/AcademicPreference";
import AddQueries from "./pages/queries/AddQueries";
import AddGroup from "./pages/groups-houses/AddGroup";
import ClassesDetails from "./pages/classes-details/ClassesDetails";
import AttendanceDetails from "./pages/attendance-details/AttendanceDetails";
import ViewGroupDetails from "./pages/view-group/ViewGroupDetails";
import { Toaster } from "sonner";
import ViewQueryDetails from "./pages/view-query-management/ViewQueryDetails";
import PtmList from "./pages/schedule-ptm/PtmList";
import NoticeBoard from "./pages/notice-board/NoticeBoard";
import CreateNotice from "./pages/notice-board/CreateNotice";
import AddNewAdmissions from "./pages/admissions/AddNewAdmissions";
import AdmissionsDetails from "./pages/admissions/AdmissionsDetails";
import HelpDesk from "./pages/help-desk/HelpDesk";
import CreateNewTickets from "./pages/help-desk/CreateNewTicket";
import ViewTicketDetails from "./pages/help-desk/ViewTicketDetails";
import MediaGallery from "./pages/media-gallery/MediaGallery";
import Exam from "./pages/exam/Exam";
import CreateExam from "./pages/create-exam/CreateExam";
import QuestionBlock from "./pages/create-exam/QuestionBlock";
import Form from "./pages/form/Form";
import CreateForm from "./pages/form/CreateForm";
import AddForm from "./pages/form/Addform";
import CreateAssignment from "./pages/assignments/CreateAssignment";
import ExamLink from "./pages/Exam-Link/ExamLink";
import FeesAndPayment from "./pages/fees-and-payment/FeesAndPayment";
import QueriesLink from "./pages/queries-form-link/QueriesLink";
import FormLink from "./pages/form-link/FormLink";
import StaffIdCard from "./pages/staff-id-card/StaffIdCard";
import StudentIdCard from "./pages/student-id-card/StudentIdCard";
import AdmissionFormLink from "./pages/admission-form-link/AdmissionFormLink";
import FormDetailsPage from "./pages/form-details-page/FormDetailsPage";
import StaffAttendance from "./pages/staff-attendance/StaffAttendance";
import ProfilePage from "./pages/profile/ProfilePage";
import PayrollManagement from "./pages/payroll-management/PayrollManagement";
import AddPayroll from "./pages/payroll-management/AddPayroll";
import CalendarAndEvent from "./pages/calendar-and-event/CalendarAndEvent";
import StaffOverview from "./pages/payroll-management/StaffOverview";
import TimeTable from "./pages/time-table/TimeTable";
import StaffAttendanceData from "./pages/staff-attendance-report/StaffAttendanceData";
import StudentAttendanceData from "./pages/students-attendance-report/StudentsAttendanceReport";
import ViewInvoicePage from "./pages/fees-and-payment/ViewInvoicePage";
import EscortIdCard from "./pages/attender-id-card/EscortIdCard";
import AssignmentSubmissionList from "./pages/assignments/AssignmentSubmissionList";
import DeleteAccount from "./pages/delete-account/DeleteAccount";

function App() {
  return (
    <Router>
      <Toaster position="bottom-right" richColors />
      <Routes>
        {/* <Route element={<EmpedanceMainLayout />}>
        </Route> */}
        <Route
          element={
            <ProtectedRoute>
              <EmpedanceMainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Home />} />

          <Route path="/staff" element={<Staff />} />
          <Route path="/staff/add-staff" element={<AddStaff />} />
          <Route
            path="staff/staff-profile/:staffId"
            element={<ViewStaffProfile />}
          />
          <Route
            path="staff/staff-profile/staff-id-card/:staffId"
            element={<StaffIdCard />}
          />
          <Route path="staff/staff-attendance" element={<StaffAttendance />} />

          <Route path="/all-students" element={<Students />} />
          <Route path="/all-students/add-student" element={<AddStudents />} />
          <Route
            path="/all-students/student-data-import"
            element={<StudentDataImport />}
          />
          <Route
            path="all-students/student-profile/:id"
            element={<ViewStudentProfile />}
          />
          <Route
            path="all-students/student-profile/id-card/:id"
            element={<StudentIdCard />}
          />

          <Route path="/escort-id-card" element={<EscortIdCard />} />

          <Route path="/classes" element={<Classes />} />
          <Route
            path="/classes/classes-details/:classId"
            element={<ClassesDetails />}
          />
          <Route
            path="/classes/attendance-details/:classId"
            element={<AttendanceDetails />}
          />

          <Route path="/groups-houses" element={<Groups />} />
          <Route path="/groups-houses/add-group" element={<AddGroup />} />
          <Route
            path="/groups-houses/view-details/:groupId"
            element={<ViewGroupDetails />}
          />
          <Route
            path="/groups-houses/edit-group/:groupId"
            element={<AddGroup />}
          />

          <Route path="/admissions" element={<Admissions />} />
          <Route
            path="/admissions/add-new-admission"
            element={<AddNewAdmissions />}
          />
          <Route
            path="/admissions/admission-details/:id"
            element={<AdmissionsDetails />}
          />

          <Route path="/services" element={<Services />} />

          <Route path="/messages" element={<Messages />} />
          <Route path="/messages/send-new-message" element={<SendMessage />} />

          <Route path="/queries" element={<Queries />} />
          <Route path="/queries/add-query" element={<AddQueries />} />
          <Route
            path="/queries/view-query/:id"
            element={<ViewQueryDetails />}
          />

          <Route path="/ptm-list" element={<PtmList />} />

          <Route path="/notice-board" element={<NoticeBoard />} />
          <Route
            path="/notice-board/create-new-notice"
            element={<CreateNotice />}
          />

          <Route
            path="/academic-preferences"
            element={<AcademicPreference />}
          />

          <Route path="/exams-and-assignments" element={<Exam />} />
          <Route
            path="/exams-and-assignments/create-exam"
            element={<CreateExam />}
          />
          <Route
            path="/exams-and-assignments/create-exam/:examId"
            element={<CreateExam />}
          />
          <Route
            path="/exams-and-assignments/create-exam/test/:examId"
            element={<QuestionBlock />}
          />
          <Route
            path="/exams-and-assignments/create-assignment"
            element={<CreateAssignment />}
          />
          <Route
            path="/exams-and-assignments/view-assignment/:id"
            element={<CreateAssignment />}
          />
          <Route
            path="/exams-and-assignments/view-submission/:id"
            element={<AssignmentSubmissionList />}
          />

          <Route path="/forms" element={<Form />} />
          <Route path="/form/create-form" element={<CreateForm />} />
          <Route path="/form/create-form/add/:formId" element={<AddForm />} />
          <Route path="/form/create-form/:id" element={<CreateForm />} />
          <Route
            path="/form/create-form/form-response/:formAnswerId"
            element={<FormDetailsPage />}
          />

          <Route path="/fees-and-payments" element={<FeesAndPayment />} />
          <Route path="/invoices/:id" element={<ViewInvoicePage />} />

          <Route path="/media-gallery" element={<MediaGallery />} />

          <Route path="/help" element={<HelpDesk />} />
          <Route
            path="/help/create-new-ticket"
            element={<CreateNewTickets />}
          />
          <Route
            path="/help/ticket-details/:ticketId"
            element={<ViewTicketDetails />}
          />
          <Route path="/view-profile" element={<ProfilePage />} />

          <Route path="/payroll-management" element={<PayrollManagement />} />
          <Route
            path="/payroll-management/add-payroll/:id"
            element={<AddPayroll />}
          />
          <Route
            path="/payroll/staff-overview/:id"
            element={<StaffOverview />}
          />

          <Route path="/calendar-and-events" element={<CalendarAndEvent />} />

          <Route path="/timetable" element={<TimeTable />} />
        </Route>

        <Route
          path="/exams-and-assignments/:branchCode/edit-customExam/:examSeqId"
          element={<ExamLink />}
        />
        <Route
          path="/queries/queries-form/:branchCode"
          element={<QueriesLink />}
        />
        <Route
          path="/queries/queries-form/:branchCode/re-share/:id"
          element={<QueriesLink />}
        />
        <Route
          path="/form/:branchCode/share/:formSeqId"
          element={<FormLink />}
        />
        <Route
          path="/student-profile/:branchCode/admission-details/:id"
          element={<AdmissionFormLink />}
        />
        <Route
          path="/staff-attendance-report/:branchCode"
          element={<StaffAttendanceData />}
        />
        <Route
          path="/students-attendance-report/:branchCode"
          element={<StudentAttendanceData />}
        />

        <Route path="/delete-account" element={<DeleteAccount/>} />

        <Route
          element={
            <AuthRoute>
              <AuthLayout />
            </AuthRoute>
          }
        >
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
